import React, { useState, useEffect } from "react"
import { Col, Row, Container, Spinner } from "reactstrap"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import withRouter from "../../components/Common/withRouter"
import logo from "../../assets/images/Logo.png"
import { Link } from "react-router-dom"
import moment from "moment"
import { postSubmitForm } from "../../helpers/backend_helper"

const ItemsInvoice = props => {
  const [selectedRow, setselected_Row] = useState()
  const [isLoading, setIsLoading] = useState(false)

  function printInvoice() {
    window.print()
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("Kitchen")) {
      loadData({ booking_id: urlParams.get("Kitchen"),section:"Kitchen"})
    }else if (urlParams.get("Cafe")) {
        loadData({ booking_id: urlParams.get("Cafe"),section:"Cafe"})
      }
  }, [])

  const filterData = (data ,type) => {
    const filteredItemDetails = data.item_details.filter(item => {
        if (type === "Kitchen") {
            return item.section === 'Kitchen';
        } else if (type === "Cafe") {
            return item.section === 'Cafe';
        }
        return false; 
    });
    return {
        ...data,
        item_details: filteredItemDetails,
    };
};

  const loadData = async (data) => {
    setIsLoading(true)
    let url = process.env.REACT_APP_BASEURL + "bookings/get_item_orders"
    const response = await postSubmitForm(url, )
    if (response && response.status === 1) {
      setIsLoading(false)
      const booking = response.data.find((bk)=>bk._id===data.booking_id)
      setselected_Row(filterData(booking, data.section));
    } else {
      setIsLoading(false)
      // showNotification(response.message, "Error");
    }
  }

  return (
    <React.Fragment>
      {isLoading === true ? (
        <div  style={{
           display:"flex",
           flexDirection:"column",
           justifyContent:"center",
           alignItems:"center",
           gap:"1rem",
           marginTop:"7rem"
                     
        }}>
          <Spinner style={{ margin:"auto", height: "4rem", width: "4rem" }} />
          <p style={{ marginTop: "10px", textAlign: "center" }}>Generating bill, please wait...</p>
        </div>
      ) : (
        <div style={{ width: "8.5cm", margin: "auto", marginTop: "70px" }}>
          <div
            className="row head"
            style={{
              width: "100%",
              margin: "auto",
              height: "50px",
              borderBottom: "1px dotted #000",
            }}
          >
            <div
              className="col col-md-2 col-sm-2 col-2"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <img
                src={logo}
                style={{
                  height: "40px",
                  borderRadius: " 50%",
                  width: "90px",
                  marginTop: "2px",
                  backgroundColor: "#000000",
                }}
              />
            </div>
            <div
              className="col col-md-10 col-sm-10 col-10 pt-1"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <p
                className=""
                style={{ color: "black", fontSize: "14px", fontWeight: "bold" }}
              >
                {/* {selectedRow?.invoice_no} فاتورة رقم */}
                <br />
                {/* PO Id : {selectedRow.po_id}<br /> */}
                <span
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "",
                  }}
                >
                  {moment(selectedRow?.createdAt).format("YYYY-MM-DD HH:mm")} [
                  {selectedRow?.booking_received_by?.name} ]
                </span>
                {/* <span style={{ display: "flex", justifyContent: "flex-end", marginTop: "" }}>{name}</span> */}
              </p>
            </div>
          </div>
          <br />
          <strong style={{ color: "black" }}>
            <div style={{ margin: "0px 2px 0px 2px" }}>
              <div className="row">
                <p>
                  <b>{props.t("Billed To")}</b>
                </p>
              </div>
              <p
                className="mb-0 date"
                style={{
                  fontSize: "14px",
                  marginTop: "-15px",
                  width: "100%",
                  margin: "auto",
                }}
              >
                <span>
                  {props.t("Name")}: &nbsp;
                  <b> {selectedRow?.customer_details?.name}</b>
                </span>
              </p>
              <p
                className="mb-0 d-flex justify-content-between"
                style={{ fontSize: "14px" }}
              >
                <span>
                  <span>{props.t("Phone")}:</span> &nbsp;
                  <b>{selectedRow?.customer_details?.mobile}</b>
                </span>
                <span>
                  <span>{props.t("Type")}:</span> &nbsp;
                  <b> {selectedRow?.customer_details?.customer_type}</b>
                </span>
              </p>
            </div>
            <div
              className="row mt-3 mb-0"
              style={{ fontSize: "14px", width: "100%", margin: "auto" }}
            >
              <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-12">
                <div
                  className="table-responsive"
                  style={{
                    width: "109%",
                    marginLeft: "-0.8rem",
                    color: "black",
                  }}
                >
                

                  {/* Foods */}
                  {selectedRow?.item_details?.length > 0 &&
                    selectedRow?.item_details?.some(
                      item => item.section !== "Accessories"
                    ) && (
                      <>
                        <div style={{ marginLeft: "2px", marginRight: "2px" , borderBottom: "1px dotted #000",}}>
                          <p
                            style={{
                              marginBottom: "1px",
                              borderBottom: "1px dotted #000",
                            }}
                          >
                            <b>{props.t("Foods ")}</b>
                          </p>
                          <table
                            id="example"
                            className="table"
                            style={{ color: "black" }}
                          >
                            {/* <thead className="bg-light"  > */}
                            <tr style={{ borderBottom: "1px dotted #000" }}>
                              <td>
                                رقم <br />
                                {props.t("S.N")}
                              </td>
                              <td>
                                الوصف <br />
                                {props.t("Description")}
                              </td>
                              <td>
                                الكمية <br />
                                {props.t("Qty.")}
                              </td>
                              {/* <td>
                                السعر <br />
                                {props.t("Price")}
                              </td>
                              <td>
                                مجموع <br />
                                {props.t("Sub Total")}
                              </td> */}
                            </tr>
                            {/* </thead> */}
                            {/* <tbody> */}
                            {selectedRow?.item_details
                              ?.filter(item => item.section !== "Accessories")
                              .map((item, index) => (
                                <tr key={index + 1}>
                                  <td>{index + 1}</td>
                                  <td>{item.name}</td>
                                  <td>
                                    {item.quantity.in_unit > 0 &&
                                      item.quantity.in_unit+" "+item.unit}
                                    {item.quantity.in_sub_unit > 0 &&
                                      item.quantity.in_sub_unit+" "+item.in_sub_unit}
                                  </td>
                                  {/* <td>{item.quantity.in_sub_unit} {item.sub_unit}</td> */}
                                  {/* <td>{item.price}</td>
                                  <td>{item.sub_total}</td> */}
                                </tr>
                              ))}
                          </table>
                        </div>
                      </>
                    )}

                 
                </div>

              </div>
            </div>
          </strong>
        </div>
      )}

      {isLoading === true ? (
        <div></div>
      ) : (
        <Row className="d-print-none col text-right pr-5 mt-5">
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Link
              to="#"
              onClick={() => {
                printInvoice()
                // localStorage.removeItem("invoiceData")
              }}
              className="btn btn-primary"
            >
              <i className="fa fa-print" /> {props.t("Print")}
            </Link>
          </Col>
        </Row>
      )}

      {/* </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div> */}
    </React.Fragment>
  )
}

export default withRouter(connect(null, {})(withTranslation()(ItemsInvoice)))
